/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Injectable } from '@angular/core';
import { User } from '@biz-nest/auth-client';
import {
  Buyer,
  Company,
  CompanySubscription,
  Customer,
  Review,
  Staff,
  getGuestInfo
} from '@biz-nest/commerce-client';
import { FrontendLogger, IcommerceUser, IecommerceGuest } from '@biz-nest/core-client';
import { DeliveryManager, EagleInfoClientError, Imanager, VendorManager } from '@main-shared-lib';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  isSuperAdmin = false;
  authUser?: User;
  currentCompany?: Company;
  buyerProfile?: Buyer;
  guestProfile?: IecommerceGuest<string, IcommerceUser>;
  staffProfile?: Staff;
  vendorManagerProfile?: VendorManager;
  deliveryManagerProfile?: DeliveryManager;
  companyProfile?: Company;
  profileType: 'buyer' | 'staff' | 'vendorManager' | 'deliveryManager' | 'company' = 'buyer';

  customers: Customer[] = [];
  users: User[] = [];
  reviews: Review[] = [];
  companyId?: string;
  subscriptions: CompanySubscription[] = [];
  activeSubscription?: CompanySubscription;

  // inv related
  stateDataRelated;

  // misc
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stateDataUserSelect: any = {};

  private chatServerUrl?: string;

  constructor() { }

  setChatServerUrl(chatServerUrl: string) {
    this.chatServerUrl = chatServerUrl;
  }


  async getCurrentCompany() {
    try {
      FrontendLogger.debug('getCurrentCompany');

      FrontendLogger.debug('getCurrentCompany companyId', this.companyId);

      if (!this.companyId) {
        FrontendLogger.error('getCurrentCompany companyId is undefined');

        return;
      }


      const company = await Company.getOne(this.companyId);

      if (company) {
        FrontendLogger.debug('SETN COMPANY');
        this.currentCompany = company;
      }
    } catch (error) {
      FrontendLogger.error(error);
    }
  }

  async getActiveSubscriptions() {
    // TODO
  }

  getUserNames(): string {
    switch (this.profileType) {
      case 'staff':
        if (!this.staffProfile) {
          return '';
        }

        return this.staffProfile.commerceUser?.firstName + ' ' + this.staffProfile.commerceUser?.lastName;
      case 'vendorManager':
        if (!this.vendorManagerProfile) {
          return '';
        }

        return this.vendorManagerProfile.manager?.firstName + ' ' + this.vendorManagerProfile.manager?.lastName;
      case 'deliveryManager':
        if (!this.deliveryManagerProfile) {
          return '';
        }

        return this.deliveryManagerProfile.manager?.firstName + ' ' + this.deliveryManagerProfile.manager?.lastName;
      case 'company':
        if (!this.companyProfile) {
          return '';
        }

        return typeof this.companyProfile.owner === 'object' ?
          this.companyProfile.owner?.firstName + ' ' + this.companyProfile.owner?.lastName : '';
      case 'buyer':
        if (!this.buyerProfile) {
          return '';
        }

        return this.buyerProfile?.firstName + ' ' + this.buyerProfile?.lastName;
      default:
        return '';
    }
  }

  getUserPhoto(): string {
    switch (this.profileType) {
      case 'staff':
        if (!this.staffProfile) {
          return '';
        }

        return this.extraxtPhoto(this.staffProfile.commerceUser);
      case 'vendorManager':
        if (!this.vendorManagerProfile) {
          return '';
        }

        return this.extraxtPhoto(this.vendorManagerProfile.manager);
      case 'deliveryManager':
        if (!this.deliveryManagerProfile) {
          return '';
        }

        return this.extraxtPhoto(this.deliveryManagerProfile.manager);
      case 'company':
        if (!this.companyProfile) {
          return '';
        }

        if (typeof this.companyProfile.owner === 'string') {
          return '';
        }

        return this.extraxtPhoto(this.companyProfile.owner);
      case 'buyer':
        if (!this.buyerProfile) {
          return '';
        }

        return this.extraxtPhoto(this.buyerProfile);
      default:
        return '';
    }
  }

  extraxtPhoto(user: IcommerceUser | Imanager | Buyer) {
    if (typeof user.photos === 'string') {
      return user.photos;
    }

    return user.profilePicture?.url || '';
  }

  getUrId(): string {
    switch (this.profileType) {
      case 'staff':
        if (!this.staffProfile) {
          return '';
        }

        return this.staffProfile.commerceUser?.urId;
      case 'vendorManager':
        if (!this.vendorManagerProfile) {
          return '';
        }

        return this.vendorManagerProfile.manager?.urId;
      case 'deliveryManager':
        if (!this.deliveryManagerProfile) {
          return '';
        }

        return this.deliveryManagerProfile.manager?.urId;
      case 'company':
        if (!this.companyProfile) {
          return '';
        }

        if (typeof this.companyProfile.owner === 'string') {
          return '';
        }

        return this.companyProfile.owner?.urId;
      case 'buyer':
        if (!this.buyerProfile) {
          return '';
        }

        return this.buyerProfile?.urId;
      default:
        return '';
    }
  }


  getUser(): IcommerceUser | Imanager | Buyer | null {
    switch (this.profileType) {
      case 'staff':
        if (!this.staffProfile) {
          return null;
        }

        return this.staffProfile.commerceUser;
      case 'vendorManager':
        if (!this.vendorManagerProfile) {
          return null;
        }

        return this.vendorManagerProfile.manager;
      case 'deliveryManager':
        if (!this.deliveryManagerProfile) {
          return null;
        }

        return this.deliveryManagerProfile.manager;
      case 'company':
        if (!this.companyProfile) {
          return null;
        }

        if (typeof this.companyProfile.owner === 'string') {
          return null;
        }

        return this.companyProfile.owner;
      case 'buyer':
        if (!this.buyerProfile) {
          return null;
        }

        return this.buyerProfile;
      default:
        return null;
    }
  }


  setCompanyId(companyId: string) {
    this.companyId = companyId;
  }

  getChatInfo() {
    const user = this.getUser();

    if (!user) {
      throw new EagleInfoClientError('user is undefined');
    }


    return {
      _id: user._id,
      names: this.getUserNames(),
      photo: this.getUserPhoto(),
      chatServerUrl: this.chatServerUrl
    };
  }

  async getGuest() {
    try {
      const guest = await getGuestInfo();

      this.guestProfile = guest;
    } catch (error) {
      FrontendLogger.error(error);
    }
  }
}

